import React from "react";

import { ChevronDown } from "@actinc/dls/icons";
import { styled } from "@mui/material/styles";
import { IconButton } from "@mui/material";

const ExpandMoreIcon = styled((props) => {
  const { expand, onClick, ...other } = props;
  return (
    <IconButton aria-label="expand icon" onClick={onClick} size="large">
      <ChevronDown {...other} />
    </IconButton>
  );
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

export { ExpandMoreIcon };
